import Select from '@/components/base/Select';
import DateRangePicker from '@/components/base/DateRangePicker';
import type { OrderFilters } from '@/pages/orders/types';

interface OrdersFiltersProps {
  filters: OrderFilters;
  onChange: (filters: OrderFilters) => void;
  onClear: () => void;
}

const priorityOptions = [
  { value: '', label: 'كل الأولويات' },
  { value: 'normal', label: 'عادي' },
  { value: 'urgent', label: 'مستعجل' },
];

const deliveryOptions = [
  { value: '', label: 'كل طرق التوصيل' },
  { value: 'توصيل واستلام', label: 'توصيل واستلام' },
  { value: 'استلام فقط', label: 'استلام فقط' },
  { value: 'توصيل فقط', label: 'توصيل فقط' },
];

const sourceOptions = [
  { value: '', label: 'كل المصادر' },
  { value: 'direct', label: 'مباشر' },
  { value: 'package', label: 'باقة' },
];

export default function OrdersFilters({ filters, onChange, onClear }: OrdersFiltersProps) {
  const hasActiveFilter =
    Boolean(filters.range.from || filters.range.to) ||
    Boolean(filters.priority) ||
    Boolean(filters.delivery) ||
    Boolean(filters.source) ||
    Boolean(filters.search);

  const update = (patch: Partial<OrderFilters>) => onChange({ ...filters, ...patch });

  return (
    <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:flex-wrap">
      <DateRangePicker
        value={filters.range}
        onChange={(range) => update({ range })}
        className="w-full lg:w-[230px]"
      />
      <Select
        value={filters.priority}
        options={priorityOptions}
        onChange={(priority) => update({ priority })}
        className="w-full lg:w-[190px]"
      />
      <Select
        value={filters.delivery}
        options={deliveryOptions}
        onChange={(delivery) => update({ delivery })}
        className="w-full lg:w-[210px]"
      />
      <Select
        value={filters.source}
        options={sourceOptions}
        onChange={(source) => update({ source })}
        className="w-full lg:w-[180px]"
      />
      <div className="relative w-full lg:w-[260px]">
        <span className="pointer-events-none absolute right-3 top-1/2 flex h-5 w-5 -translate-y-1/2 items-center justify-center text-foreground-400">
          <i className="ri-search-line text-[17px] leading-none" aria-hidden="true"></i>
        </span>
        <input
          type="search"
          value={filters.search}
          onChange={(event) => update({ search: event.target.value })}
          placeholder="ابحث برقم الطلب"
          className="h-11 w-full rounded-field border border-background-300 bg-white pe-3 ps-10 text-sm text-foreground-900 placeholder:text-foreground-400 focus:border-secondary-400 focus:outline-none focus:ring-2 focus:ring-secondary-100"
        />
      </div>
      {hasActiveFilter && (
        <button
          type="button"
          onClick={onClear}
          className="flex items-center gap-1.5 whitespace-nowrap text-[13px] font-medium text-danger-600 transition-colors hover:text-danger-700"
        >
          <i className="ri-close-circle-line text-base" aria-hidden="true"></i>
          مسح الفلاتر
        </button>
      )}
    </div>
  );
}